import { createSlice } from "@reduxjs/toolkit";
import { clearVoucherDetail, fetchVoucherDetail, getVouchersThunk, uploadFileCsv } from "./thunk";

interface VoucherState {
  loading: boolean;
  data: any[];
  voucherData: null,

  error: string | null;
}

const initialState: VoucherState = {
  loading: false,
  data: [],
  voucherData: null,
  error: null
};

const vouchersSlice = createSlice({
  name: "vouchers",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVouchersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVouchersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getVouchersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(fetchVoucherDetail.pending, (state) => {
        state.loading = true;  // ✅ Jab API call ho rahi ho
      })
      .addCase(fetchVoucherDetail.fulfilled, (state: any, action: any) => {
        state.loading = false;
        if (state.voucherData == null) {
          state.voucherData ={}
        }
        state.voucherData = action.payload || null;
        state.counts = action.payload?.counts || 0;
        state.error = null;
      })
      .addCase(fetchVoucherDetail.rejected, (state:any, action:any) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
    builder.addCase(uploadFileCsv.fulfilled, (state: any, action: any) => {
        state.productUpload = action?.payload?.data
      });
  
      builder.addCase(uploadFileCsv.rejected, (state: any, action: any) => {
        state.error = action.payload.error || null;
      })
      .addCase(clearVoucherDetail.fulfilled, (state: any, action: any) => {
        state.voucherData = action.payload.voucherData;
        state.counts = action.payload.counts;
        state.error = action.payload.error;
      })
  }
});

export default vouchersSlice.reducer;
